import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Link } from 'react-router-dom';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import markLogo from 'src/assets/logos/aragon-logo-mark.svg';
import responsive from 'src/constants/responsive';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';

export type FooterProps =
    React.HTMLAttributes<HTMLElement> &
    {
        loading: boolean;
    };

const styles = {
    container: {
        position: 'relative',
        background: 'white'
    },
    content: {
        display: 'flex',
        height: '100%',
        opacity: 0,
        transform: 'translate3d(0, -100%, 0)',
        transition: 'all 0.7s ease-out',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...stylesheet.PaddingGutter(1, directions.all),
        ...stylesheet.Footer,
        whiteSpace: 'nowrap'
    },
    contentMobile: {
        [responsive.Mobile]: {
            flexDirection: 'column'
        }
    },
    footerText: {
        flex: 1
    },
    backTotop: {
        flex: 1,
        whiteSpace: 'nowrap',
        textAlign: 'right'
    },
    logo: {
        flex: 0,
        [responsive.Mobile]: {
            height: 30,
            ...stylesheet.MarginGutter(.5, directions.top | directions.bottom)
        },
        [responsive.AfterMobile]: {
            height: 40,
        }
    },
    logoIcon: {
        height: '100%',
        width: 'auto',
        maxWidth: 'none',
        cursor: 'pointer'
    },
    loaded: {
        '& $content': {
            opacity: 1,
            transform: 'translate3d(0, 0, 0)',
        }
    },
    line: {
        '&:before': {
            content: '""',
            position: 'absolute',
            top: -1,
            display: 'block',
            height: 1,
            margin: '0 auto',
            backgroundColor: 'black',
            ...stylesheet.PostionGutter(1, directions.sides)
        }
    },
    secondaryLink: {
        display: 'inline-block',
        marginLeft: 10
    }, 
};

type Props =
    FooterProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps &
    InjectedApiProps;

type State = {
};

class Footer extends React.Component<Props, State> {
    public readonly state: State = {};

    render() {

        const {
            children,
            classes,
            loading,
            appScrollerCtx,
            // appScrollerCtx: { Top },
            apiCtx,
            apiCtx: { app },
            ...rest } = this.props;

        // const backToTopText = Language === 'en' ? 'Back to top' : 'Haut de page';
        const conpyrightText = Language === 'en' ? '© ARAGON, ALL RIGHTS RESERVED' : '© ARAGON, TOUS DROITS RÉSERVÉS';
        return (

            <footer
                {...rest}
                className={
                    classNames(
                        classes!.container,
                        classes!.line,
                        !loading && classes!.loaded,
                        rest.className
                    )
                }
                data-footer="true"
            >
                <div
                    className={
                        classNames(
                            classes!.content,
                            classes!.contentMobile
                        )
                    }
                >
                    <div className={classes!.footerText}>
                        {conpyrightText}
                    </div>
                    <div className={classes!.logo} >
                        <img src={markLogo} className={classes!.logoIcon} />
                    </div>
                    <div className={classes!.backTotop}>
                        {app && app.SecondaryMenus.map(sm =>
                            <Link
                                key={sm.UID}
                                to={`${sm.Url}`}
                                className={classes!.secondaryLink}
                            >
                                {sm.Title}
                            </Link>
                        )}
                    </div>
                    {children}
                </div>
            </footer>
        );
    }

}

export default withStyles(styles)(withAppScroller(withApi(Footer)));


// WEBPACK FOOTER //
// ./src/components/Footer.tsx